'use client';

import { APP_ROUTE_NAMES, PUBLIC_ROUTES } from '@/configs/routes';
import useCurrentOrganisation from '@/hooks/studbook/useCurrentOrganisation';
import { Breadcrumbs, Link, Typography, Box, Skeleton } from '@/primitives';
import { Home as HomeIcon } from '@mui/icons-material';
import CircleIcon from '@mui/icons-material/Circle';
import { Theme, useMediaQuery } from '@mui/material';
import Image from 'next/image';

interface SearchBreadcrumbsProps {
  orgName: string;
}

export default function SearchBreadcrumbs({ orgName }: SearchBreadcrumbsProps) {
  const currentOrg = useCurrentOrganisation();
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm'),
  );
  return (
    <Box sx={{ px: 2, py: isMobile ? 1 : 2 }}>
      <Breadcrumbs
        aria-label="breadcrumb"
        separator={<CircleIcon sx={{ fontSize: 12 }} />}
        sx={{ color: 'text.primary' }}
      >
        <Link
          color="inherit"
          href={PUBLIC_ROUTES.HOME}
          sx={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
          }}
        >
          <HomeIcon />
        </Link>
        <Link
          color="inherit"
          href={PUBLIC_ROUTES.SEARCH}
          sx={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
          }}
        >
          {APP_ROUTE_NAMES.SEARCH}
        </Link>
        {currentOrg.loading ? (
          <Skeleton width={100} />
        ) : (
          <Typography
            color="text.primary"
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            {currentOrg.orgImgUrl && (
              <Image
                src={currentOrg.orgImgUrl}
                alt={orgName}
                width={24}
                height={24}
                style={{ borderRadius: '50%', marginRight: 8 }}
              />
            )}
            {currentOrg.description.trim()}
          </Typography>
        )}
      </Breadcrumbs>
    </Box>
  );
}
